import DealerRepository from './DealerRepository.js'

const PHONE_TRACKING_KEY = 'mt-phone-tracking-session'

export class SessionStorageDealerRepository extends DealerRepository {
  /**
   * @method
   * @param {string} value
   */
  getTrackingPhone() {
    return window.sessionStorage.getItem(PHONE_TRACKING_KEY)
  }

  setTrackingPhone({sessionId}) {
    window.sessionStorage.setItem(PHONE_TRACKING_KEY, sessionId)
  }
}
